export const GET_SCHEDULES_BEGIN = 'GET_SCHEDULES_BEGIN'
export const GET_SCHEDULES_SUCCESS = 'GET_SCHEDULES_SUCCESS'
export const GET_SCHEDULES_ERROR = 'GET_SCHEDULES_ERROR'

export const GET_EMPLOYEES_FILTER_BEGIN = 'GET_EMPLOYEES_FILTER_BEGIN'
export const GET_EMPLOYEES_FILTER_SUCCESS = 'GET_EMPLOYEES_FILTER_SUCCESS'
export const GET_EMPLOYEES_FILTER_ERROR = 'GET_EMPLOYEES_FILTER_ERROR'

export const GET_POSITION_FILTER_BEGIN = 'GET_POSITION_FILTER_BEGIN'
export const GET_POSITION_FILTER_SUCCESS = 'GET_POSITION_FILTER_SUCCESS'
export const GET_POSITION_FILTER_ERROR = 'GET_POSITION_FILTER_ERROR'

export const GET_DEPARTMENT_FILTER_BEGIN = 'GET_DEPARTMENT_FILTER_BEGIN'
export const GET_DEPARTMENT_FILTER_SUCCESS = 'GET_DEPARTMENT_FILTER_SUCCESS'
export const GET_DEPARTMENT_FILTER_ERROR = 'GET_DEPARTMENT_FILTER_ERROR'

export const GET_STORE_ACTIVE_EMPLOYEES_BEGIN =
  'GET_STORE_ACTIVE_EMPLOYEES_BEGIN'
export const GET_STORE_ACTIVE_EMPLOYEES_SUCCESS =
  'GET_STORE_ACTIVE_EMPLOYEES_SUCCESS'
export const GET_STORE_ACTIVE_EMPLOYEES_FAILED =
  'GET_STORE_ACTIVE_EMPLOYEES_FAILED'


export const UPDATE_FILTER = 'UPDATE_FILTER'

export const SEND_EMAIL_WEEKLY_WORK_SCHEDULES_TO_EMPLOYEES_BEGIN =
  'SEND_EMAIL_WEEKLY_WORK_SCHEDULES_TO_EMPLOYEES_BEGIN'
export const SEND_EMAIL_WEEKLY_WORK_SCHEDULES_TO_EMPLOYEES_SUCCESS =
  'SEND_EMAIL_WEEKLY_WORK_SCHEDULES_TO_EMPLOYEES_SUCCESS'
export const SEND_EMAIL_WEEKLY_WORK_SCHEDULES_TO_EMPLOYEES_FAILED =
  'SEND_EMAIL_WEEKLY_WORK_SCHEDULES_TO_EMPLOYEES_FAILED'

export const SEND_SMS_WEEKLY_WORK_SCHEDULES_TO_EMPLOYEES_BEGIN =
  'SEND_SMS_WEEKLY_WORK_SCHEDULES_TO_EMPLOYEES_BEGIN'
export const SEND_SMS_WEEKLY_WORK_SCHEDULES_TO_EMPLOYEES_SUCCESS =
  'SEND_SMS_WEEKLY_WORK_SCHEDULES_TO_EMPLOYEES_SUCCESS'
export const SEND_SMS_WEEKLY_WORK_SCHEDULES_TO_EMPLOYEES_FAILED =
  'SEND_SMS_WEEKLY_WORK_SCHEDULES_TO_EMPLOYEES_FAILED'
